export const transformRuleTypes = (arr) => {
  const resultArr = [];
  arr.forEach((ruleType) => {
    ruleType.forEach((el) => {
      resultArr.push(el);
    });
  });
  return resultArr;
};
